/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_TitleInputs */

const es_admin_billing_title = /** @type {(inputs: Admin_Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación`)
};

const en_admin_billing_title = /** @type {(inputs: Admin_Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Admin_Billing_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_title = /** @type {((inputs?: Admin_Billing_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_title(inputs)
	return en_admin_billing_title(inputs)
});
export { admin_billing_title as "admin.billing.title" }